import { render } from "./parent.vue?vue&type=template&id=658defdf&scoped=true&ts=true"
import script from "./parent.vue?vue&type=script&lang=ts"
export * from "./parent.vue?vue&type=script&lang=ts"

import "./parent.vue?vue&type=style&index=0&id=658defdf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658defdf"]])

export default __exports__